/*eslint-disable no-constant-condition */
import React, { useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import {
  Accordion,
  Tabs,
  Tab,
  Card,
  Row,
  Col,
  Container,
} from 'react-bootstrap';
import { CostCard } from './CostCard';
import CustomClientError from '../../../../errorhandling/CustomClientError';
import {
  AccordionDownArrow,
  AccordionUpArrow,
} from '../../../../img/findcare/FindCareSVG';
import '../../coverage/index.scss';
import Skeleton from '../../coverage/coverage-details/skeleton/GenericSkeleton';
import APIEndpoints from 'src/Admin/api/APIEndpoints';
import { axiosInstance } from '../../../../../api/axios';
import MasterPermissions from '../../../../api/MasterPermissions';

const ServiceDetails = [
  {
    ServicesDetail: [
      {
        URL: '',
        BenefitID: 'Benefit',
        BenefitText: 'ACU',
        ServiceType: 'Accupuncture',
        ServiceTypeCode: '47',
        ServiceDetailText:
          'Acupuncture involves the insertion of very thin needles through your skin at strategic points on your body.',
        ServiceDescription: '',
      },
      {
        URL: '',
        BenefitID: 'Benefit',
        BenefitText: 'CHR',
        ServiceType: 'Chiropractic',
        ServiceTypeCode: '47',
        ServiceDetailText:
          'Procedure in which trained specialists (chiropractors) use their hands or a small instrument to apply a controlled, sudden force to a spinal joint. The goal of this procedure, also known as spinal manipulation, is to improve spinal motion and improve your bodys physical function',
        ServiceDescription: '',
      },
    ],
    ServiceGroupName: 'Professional Services',
  },
  {
    ServicesDetail: [
      {
        URL: '',
        BenefitID: 'Benefit',
        BenefitText: 'IHC',
        ServiceType: 'Inpatient- Hospital Room and Board',
        ServiceTypeCode: '48',
        ServiceDetailText:
          'Inpatient care refers to medical services that require a patient to be admitted by a doctor into a hospital or other health care facility',
        ServiceDescription: '',
      },
    ],
    ServiceGroupName: 'Inpatient Hospital Facility',
  },
  {
    ServicesDetail: [
      {
        URL: '',
        BenefitID: 'Benefit',
        BenefitText: 'AMA',
        ServiceType: 'Air Ambulance services',
        ServiceTypeCode: '47',
        ServiceDetailText:
          'An air ambulance transports a patient to a medical centre for treatment. Such aircraft are equipped to provide emergency care on board',
        ServiceDescription: '',
      },
      {
        URL: '',
        BenefitID: 'Benefit',
        BenefitText: 'AMB',
        ServiceType: 'Ground Ambulance services',
        ServiceTypeCode: '47',
        ServiceDetailText:
          ' A vehicle used to transport people who are sick or injured. Most ambulances are either trucks with space for patients or cargo vans with raised roofs. Ambulances usually take patients to a hospital.',
        ServiceDescription: '',
      },
    ],
    ServiceGroupName: 'Ambulance',
  },
  {
    ServicesDetail: [
      {
        URL: '',
        BenefitID: 'Benefit',
        BenefitText: 'ERI',
        ServiceType: 'Emergency Room',
        ServiceTypeCode: '52',
        ServiceDetailText:
          'Emergency Room-hospital facility that is staffed 24 hours a day, 7 days a week, and provides unscheduled outpatient services to patients whose condition requires immediate attention.',
        ServiceDescription: '',
      },
    ],
    ServiceGroupName: 'Emergency Room Care',
  },
  {
    ServicesDetail: [
      {
        URL: '',
        BenefitID: 'Benefit',
        BenefitText: 'HHC',
        ServiceType: 'Home Health Care',
        ServiceTypeCode: '42',
        ServiceDetailText:
          'A wide range of health care services that can be given in your home for an illness or injury. Home health care is usually less expensive, more convenient, and just as effective as care you get in a hospital or skilled nursing facility',
        ServiceDescription: '',
      },
      {
        URL: '',
        BenefitID: 'Benefit',
        BenefitText: 'HSP',
        ServiceType: 'Hospice',
        ServiceTypeCode: '45',
        ServiceDetailText:
          'The services are provided by a team of health care professionals who maximize comfort for a person who is terminally ill by reducing pain and addressing physical, psychological, social and spiritual needs.',
        ServiceDescription: '',
      },
    ],
    ServiceGroupName: 'Homecare',
  },
  {
    ServicesDetail: [
      {
        URL: '',
        BenefitID: 'Benefit',
        BenefitText: 'WCI',
        ServiceType: 'Preventive Diagnostic',
        ServiceTypeCode: '81',
        ServiceDetailText:
          'Preventive Diagnostic- Screening tests are used to find out whether people who do not show any symptoms have a previously undetected medical condition',
        ServiceDescription: '',
      },
      {
        URL: '',
        BenefitID: 'Benefit',
        BenefitText: 'WCX',
        ServiceType: 'Well Baby & Well Child Care',
        ServiceTypeCode: '68',
        ServiceDetailText:
          'The health care provider will check the childs growth and development in order to find or prevent problems. The provider will record your childs height, weight, and other important information. Hearing, vision, and other screening tests will be part of some visits',
        ServiceDescription: '',
      },
    ],
    ServiceGroupName: 'Preventive Care',
  },
];
const CoveredServicesCost = (PlanInfo) => {
  const [dataFetching, setDataFetching] = useState(false);
  const [isNotFound, setIsNotFound] = useState(false);
  const [isAPIFailed, setIsAPIFailed] = useState(false);
  const [coveredservicesDetails, setCoveredservicesDetails] = useState([]);
  const [activeIds, setActiveIds] = useState([0]);
  const [currentActiveTab, setCurrentActiveTab] = useState(
    ServiceDetails[0]?.ServicesDetail[0]?.ServiceType,
  );
  const [activeId, setActiveId] = useState(null);
  const { Network_Setting } =
    useSelector((state) => state.app?.appConfigs) || {};
  const displayBenfBy =
    Network_Setting.Value_Network_For_Coverage_Admin === 'network' ? 'N' : 'T';
  console.log('selected user data from main component is >>>>', PlanInfo);

  const {
    masterId,
    memberType,
    selectedCoverage,
    currentUserOid,
    selectedServiceCodeName,
    effectiveDate,
    benefitPlan,
    selectedNetwork,
    isFamilySelected,
  } = PlanInfo;
  const selectFirstItem = useRef();
  console.log(' selectedNetwork?.value ', selectedNetwork?.value);
  const getAccumulatorData = async () => {
    let paramString = '';
    try {
      paramString += `${memberType}/oid/${currentUserOid}/Product/${
        selectedCoverage?.value
      }/Service/${
        selectedServiceCodeName.value
      }/EffectiveDate/${effectiveDate}/MasterID/${masterId}/BenefitPlan/${btoa(
        benefitPlan,
      )}`;

      if (displayBenfBy === 'N') {
        paramString += `/NetworkID/${
          selectedNetwork?.value || 0
        }/DisplyBenfBy/${displayBenfBy}`;
      } else {
        paramString += `/TierID/${selectedNetwork?.label}/DisplyBenfBy/${displayBenfBy}`;
      }
      const responseMember = await axiosInstance.get(
        APIEndpoints.getAccumulatorDataResource() + paramString,
      );

      console.log(
        'get accumulator data response for Member =====',
        responseMember,
      );
      const accumsResponse =
        responseMember.data.Response.Response.ServiceDetail.Network;
      if (responseMember.data.Response.Response.Service === '30') {
        const filteredRes = [];
        accumsResponse.map((accum) => {
          if (accum.ServiceType === '30') {
            filteredRes.push(accum);
          }
        });

        setCoveredservicesDetails(filteredRes);
      } else {
        setCoveredservicesDetails(accumsResponse);
      }
      setIsNotFound(false);
      setIsAPIFailed(false);
    } catch (error) {
      console.log('get accumulator data error for Member =====', error);

      setActiveIds();
      if (error.toString().includes('404')) {
        setIsNotFound(true);
      }
      setIsAPIFailed(true);
    } finally {
      setDataFetching(false);
    }
  };

  useEffect(() => {
    setDataFetching(true);
    if (selectedCoverage && masterId) {
      getAccumulatorData();
    }
  }, [
    masterId,
    memberType,
    selectedCoverage,
    currentUserOid,
    selectedServiceCodeName,
    effectiveDate,
    benefitPlan,
    selectedNetwork,
    isFamilySelected,
  ]);
  const toggleActive = (id) => {
    if (activeId === id) {
      setActiveId(null);
    } else {
      setActiveId(id);
    }
  };
  //const toggleActive = (id, serviceType) => {
  //if (activeIds && activeIds.includes(id)) {
  //const updatedIds = [...activeIds];

  //updatedIds.splice(updatedIds.indexOf(id), 1);

  //setActiveIds(updatedIds);
  //} else {
  //setCurrentActiveTab(serviceType);

  //const curretnIds = [...activeIds];

  //curretnIds.push(id);

  //setActiveIds(curretnIds);
  //}
  //};
  //if (MasterPermissions.CheckPermission('View Covered Services')) {
  //setTimeout(() => {
  //makeFirstAccordionActive();
  //}, 10);
  //}
  useEffect(() => {
    makeFirstAccordionActive();
  }, []);
  const makeFirstAccordionActive = () => {
    selectFirstItem?.current?.click();
  };

  const placeRef = (index) => {
    if (index === 0) {
      return selectFirstItem;
    } else {
      return;
    }
  };
  return (
    <>
      {isAPIFailed ? (
        <div className="px-0">
          {isNotFound ? (
            <CustomClientError
              ErrorHeading="No data found!"
              ErrorMessage="Copay details not available for this selection. Change your selection criteria and try again."
            />
          ) : (
            <CustomClientError
              ErrorHeading="Something went wrong with request!"
              ErrorMessage="Please try again."
              CustomClasses="p-0"
            />
          )}
        </div>
      ) : (
        <>
          {dataFetching ? (
            <Skeleton />
          ) : (
            MasterPermissions.CheckPermission('View Covered Services') &&
            coveredservicesDetails && (
              <Card className="plan-info-card">
                <Row>
                  <Col className="">
                    <h4 className="card-title">Covered Services and Costs</h4>
                  </Col>
                </Row>
                <Row>
                  <Col className="">
                    <div>
                      <div>
                        {/*<CostCard
                          PlanInfo={PlanInfo}
                          accumsDetails={coveredservicesDetails}
                          dataFetching={dataFetching}
                          isFamilySelected={isFamilySelected}
                        />
                      </div> */}

                        <Accordion defaultActiveKey="0">
                          <>
                            <div>
                              <Accordion.Toggle
                                as={Card.Header}
                                className="card-header panel-toggle text-left w-100"
                                variant="link"
                                eventKey="0"
                                onClick={() => toggleActive(0)}
                                //ref={placeRef(Index)}
                              >
                                <span className="arrow">
                                  {activeId === 0 ? (
                                    <AccordionUpArrow className="acc-arrow" />
                                  ) : (
                                    <AccordionDownArrow className="acc-arrow" />
                                  )}
                                </span>
                                {selectedServiceCodeName.label}
                              </Accordion.Toggle>
                              <Accordion.Collapse eventKey="0">
                                <Card.Body>
                                  <div>
                                    <CostCard
                                      PlanInfo={PlanInfo}
                                      accumsDetails={coveredservicesDetails}
                                      isNotFound={isNotFound}
                                      isAPIFailed={isAPIFailed}
                                      dataFetching={dataFetching}
                                      isFamilySelected={isFamilySelected}
                                    />
                                  </div>
                                </Card.Body>
                              </Accordion.Collapse>
                            </div>
                          </>
                        </Accordion>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Card>
            )
          )}
        </>
      )}
    </>
  );
};

export default CoveredServicesCost;
